export default __webpack_public_path__ + "static/media/chat_icon.4a3e0601.svg";